import React from 'react';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import { Icon } from '../Icon';
import { useStore } from '@store/StoreProvider';

const CRYPTO = [
  { sym: '₮', color: '#26A17B', name: 'USDT', net: 'TRC-20' },
  { sym: '₮', color: '#26A17B', name: 'USDT', net: 'ERC-20' },
  { sym: '₮', color: '#26A17B', name: 'USDT', net: 'BEP-20' },
  { sym: '$', color: '#2775CA', name: 'USDC', net: 'ERC-20' },
  { sym: '₿', color: '#F7931A', name: 'Bitcoin', net: 'BTC' },
  { sym: 'Ξ', color: '#627EEA', name: 'Ethereum', net: 'ETH' },
  { sym: '◆', color: '#0098EA', name: 'Toncoin', net: 'TON' },
  { sym: 'T', color: '#EF0027', name: 'Tron', net: 'TRX' },
  { sym: 'Ł', color: '#345D9D', name: 'Litecoin', net: 'LTC' },
  { sym: 'B', color: '#F0B90B', name: 'BNB', net: 'BEP-20' },
  { sym: '◎', color: '#9945FF', name: 'Solana', net: 'SOL' },
  { sym: 'ɱ', color: '#FF6600', name: 'Monero', net: 'XMR' },
] as const;

export const CtaSection = observer(() => {
  const { auth, i18n } = useStore();
  const isLoggedIn = auth.isAuthenticated;
  void i18n.language
  void i18n.version
  const tf = (key: string) => i18n.t(key)

  return (
    <section id="cta" className="relative py-14 sm:py-20 scroll-mt-24">
      <div id="partners" className="absolute -top-24 pointer-events-none" aria-hidden="true" />
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <div className="relative rounded-[2rem] overflow-hidden border border-brand/30 px-6 py-12 sm:p-14 bg-deep2/60">
          <canvas id="ctaFlow" className="absolute inset-0 w-full h-full" />
          <div className="absolute inset-0 bg-gradient-to-br from-brand/20 via-indigo-600/10 to-transparent pointer-events-none" />

          <div className="land-desktop-block absolute left-5 top-9 w-56 -rotate-[7deg] opacity-95 pointer-events-none">
            <div className="rounded-2xl border border-white/10 bg-[#0b1020]/90 backdrop-blur p-3.5 shadow-2xl shadow-black/50">
              <div className="flex items-center gap-2.5 mb-2.5">
                <span className="grid place-items-center w-8 h-8 rounded-xl bg-gradient-to-br from-brand to-indigo-500 text-white font-extrabold text-xs">X</span>
                <div>
                  <div className="text-xs font-semibold">ChatX Bot</div>
                  <div className="text-[10px] text-emerald-400">● {tf('app.status.online').toLowerCase()}</div>
                </div>
              </div>
              <div className="space-y-1.5">
                <div className="text-[11px] bg-white/8 rounded-lg rounded-bl-sm px-2.5 py-1.5 inline-block">
                  {tf('demo.messages.hello')}
                </div>
                <div className="text-[11px] bg-brand text-white rounded-lg rounded-br-sm px-2.5 py-1.5 inline-block ml-auto block w-fit">
                  Чем можем помочь?
                </div>
              </div>
            </div>
          </div>
          <div className="land-desktop-block absolute right-5 bottom-9 w-52 rotate-[6deg] opacity-95 pointer-events-none">
            <div className="rounded-2xl border border-brand/30 bg-[#0b1020]/90 backdrop-blur p-3.5 shadow-2xl shadow-black/50">
              <div className="flex items-center justify-between mb-2.5">
                <span className="ic-badge" style={{ width: 30, height: 30 }}>
                  <Icon id="ic-send" className="ic ic-sm" />
                </span>
                <span className="text-[10px] text-brand2 font-semibold">Telegram</span>
              </div>
              <div className="text-[11px] text-slate-300">{tf('demo.new_request')}</div>
              <div className="mt-2 h-1.5 rounded-full bg-white/10 overflow-hidden">
                <div className="h-full w-2/3 bg-gradient-to-r from-brand to-cyan-400" />
              </div>
              <div className="mt-1.5 text-[10px] text-slate-500">
                {tf('widget.client.operator_replying')}…
              </div>
            </div>
          </div>

          <div className="relative text-center">
            <div className="reveal inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/15 glass text-xs font-semibold mb-6">
              <Icon id="ic-rocket" className="ic ic-sm text-brand2" />
              {tf('billing.trial.full_access')}
            </div>
            <h2 className="reveal text-3xl sm:text-5xl font-extrabold leading-tight">
              {tf('landing.cta.try_title')}
              <br />
              <span className="text-gradient">{tf('billing.trial.first_days_free')}</span>
            </h2>
            <p className="reveal mt-5 text-slate-300 text-lg max-w-xl mx-auto">
              {tf('billing.trial.description')}
            </p>

            <div className="reveal mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-slate-300">
              <span className="inline-flex items-center gap-2">
                <Icon id="ic-check" className="ic ic-sm text-emerald-400" /> {tf('billing.trial.no_card')}
              </span>
              <span className="inline-flex items-center gap-2">
                <Icon id="ic-check" className="ic ic-sm text-emerald-400" /> {tf('landing.launch_in_5_minutes')}
              </span>
              <span className="inline-flex items-center gap-2">
                <Icon id="ic-check" className="ic ic-sm text-emerald-400" /> Без автосписаний
              </span>
            </div>

            {isLoggedIn ? (
              <Link
                to="/myProfile"
                className="reveal inline-flex mt-8 px-9 py-4 rounded-2xl cta-glow font-bold text-lg text-white shadow-2xl shadow-brand/50 transition hover:scale-[1.03] active:scale-95"
              >
                {tf('nav.to_profile')} →
              </Link>
            ) : (
              <a
                href="/register"
                className="reveal inline-flex mt-8 px-9 py-4 rounded-2xl cta-glow font-bold text-lg text-white shadow-2xl shadow-brand/50 transition hover:scale-[1.03] active:scale-95"
              >
                {tf('landing.cta.start_trial')}
              </a>
            )}
          </div>
        </div>

        <div className="reveal mt-6 rounded-3xl border border-white/10 bg-panel/30 overflow-hidden">
          <div className="flex items-center justify-center gap-3 px-6 pt-7 pb-6">
            <span className="h-px flex-1 max-w-20 bg-gradient-to-r from-transparent to-white/10" />
            <span className="text-[11px] uppercase tracking-[0.18em] text-slate-500 font-extrabold">
              {tf('billing.methods.accepted_title')}
            </span>
            <span className="h-px flex-1 max-w-20 bg-gradient-to-l from-transparent to-white/10" />
          </div>

          <div className="grid lg:grid-cols-[1.55fr_1fr]">
            <div className="px-6 pb-7 lg:pr-8 lg:border-r lg:border-white/5">
              <div className="pay-head">
                <Icon id="ic-bolt" className="ic ic-sm" /> Криптовалюта
                <span className="pay-note">сеть указана на счёте</span>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                {CRYPTO.map((c) => (
                  <span key={`${c.name}-${c.net}`} className="coin">
                    <i style={{ ['--c' as string]: c.color }}>{c.sym}</i>
                    <b>
                      {c.name}
                      <em>{c.net}</em>
                    </b>
                  </span>
                ))}
              </div>
            </div>

            <div className="px-6 pb-7 lg:pl-8 border-t border-white/5 pt-6 lg:border-t-0 lg:pt-0">
              <div className="pay-head">
                <Icon id="ic-card" className="ic ic-sm" /> Карты и переводы
              </div>
              <div className="flex flex-wrap gap-2">
                {['СБП', 'Мир', 'Visa', 'MasterCard'].map((m) => (
                  <span key={m} className="pay-chip">
                    {m}
                  </span>
                ))}
              </div>

              <div className="pay-head mt-6">
                <Icon id="ic-zap" className="ic ic-sm" /> Быстрая оплата
              </div>
              <div className="flex flex-wrap gap-2">
                <span className="pay-chip">Apple&nbsp;Pay</span>
                <span className="pay-chip">Google&nbsp;Pay</span>
              </div>

              <div className="mt-6 flex items-start gap-2.5 text-[12px] text-slate-500 leading-relaxed">
                <Icon id="ic-shield" className="ic ic-sm shrink-0 mt-0.5" />
                <span>
                  Реквизиты карт и кошельков обрабатывает платёжный провайдер — ChatX их не получает и
                  не хранит.
                </span>
              </div>
            </div>
          </div>

          <div className="px-6 py-4 border-t border-white/5 bg-deep/30 text-[12.5px] text-slate-500 text-center">
            Счёт формируется при выборе тарифа — способ оплаты выбираете на нём. Автосписаний нет.
          </div>
        </div>
      </div>
    </section>
  );
});
